export const FIX_OCR_STORE_ID_PARAM = 'fx_store_id';

// Legacy param used before namespacing.
export const FIX_OCR_STORE_ID_PARAM_LEGACY = 'storeId';

